// extracted by mini-css-extract-plugin
module.exports = {"root":"NotAccess_root__RCfKD","content":"NotAccess_content__3xsK8"};